<template>
  <div class="notification-list">
    <v-card>

        <v-app-bar flat >
          <v-icon>mdi-bell</v-icon>
          <v-toolbar-title class="title pl-1">
            {{$t('menu.notification.notifications')}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu left bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item
                  @click="viewall"
                >
                  <v-list-item-title>
                  <v-icon right dark>mdi-delete-circle</v-icon>{{$t('global.clear')}}
                  </v-list-item-title>

                </v-list-item>

              </v-list>
            </v-menu>
        </v-app-bar>
      <v-card-text>

        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="items"
          :items-per-page.sync="options.itemsPerPage"
          :footer-props="footer"
          :loading="isLoading"
          :loading-text="$t('global.loading')"
          :options.sync="options"
          :server-items-length="totalItems"
          class="elevation-1"
          item-key="@id"

          @update:options="onUpdateOptions"
          @click:row="showHandler"
@contextmenu:row="showHandlerExt"
        >
            <template slot="item.type.type" slot-scope="{ item }">

              <v-icon v-if="item.view" >{{ icon(item.type.type) }}</v-icon>
              <v-icon color="primary" v-else>{{ icon(item.type.type) }}</v-icon>
            </template>
            <template slot="item.date" slot-scope="{ item }">

                <strong v-if="item.view == false">{{ formatDateTime(item['date'], 'long') }}</strong>
                <span v-else>{{ formatDateTime(item['date'], 'long') }}</span>
            </template>
            <template slot="item.data" slot-scope="{ item }">
              <strong v-if="item.view == false" >
                <span class="d-none d-sm-flex">{{ $t(item.type.name, item.data) }}</span>
                <span class="d-flex d-sm-none">...</span>
              </strong>
              <span v-else>
                <span class="d-none d-sm-flex">{{ $t(item.type.name, item.data) }}</span>
                <span class="d-flex d-sm-none">...</span>
              </span>
            </template>

        </v-data-table>


      </v-card-text>
    </v-card>
  </div>

</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';

export default {
  name: 'NotificationList',
  servicePrefix: 'Notification',
  mixins: [ListMixin],
  components: {
  },
  data() {
    return {
      headers: [
      { text: this.$t('global.type'), value: 'type.type' , width: 80 },
      { text: this.$t('global.date'), value: 'date' },
      { text: this.$t('global.content'), value: 'data' },
    ],
    filters: {
      'view' : false,
    },

    selected: [],
    footer: {
      'itemsPerPageText': "",
    },
    options: {sortBy : ['date'], sortDesc : [true]}
    };
  },
  computed: {
    ...mapGetters('notificationuser', {
      items: 'list'
    }),
    ...mapFields('notificationuser', {
      actioned: 'actioned',
      action: 'action',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('notificationuser', {
      getPage: 'fetchAll',
      deleteItem: 'del',
      notificationuserPushAction: 'action'
    }),
    icon(type) {
      if (type == 'security') return 'mdi-security';
      if (type == 'machine') return 'mdi-printer-3d';
      if (type == 'toolhead') return 'mdi-tools';
      if (type == 'materialsupply') return 'mdi-format-color-fill';
      if (type == 'industrialcomputer') return 'mdi-server';
      if (type == 'operatingsystem') return 'mdi-microsoft-windows';
      if (type == 'printingsurface') return 'mdi-checkerboard';
      if (type == 'controlunit') return 'mdi-car-cruise-control';
      if (type == 'accessory') return 'mdi-cctv';
      if (type == 'option') return 'mdi-toy-brick-plus';

      return 'mdi-bell';
    },
    viewall() {
      this.notificationuserPushAction({action: 'viewall',values: {}});
    },
    updatedviewall(actioned) {
      console.log("updatedviewall");
      this.showMessage(actioned.message);
    },
  },
  watch: {
    actioned(actioned) {
      if (!actioned) {
        return;
      }
      if (this.action == 'viewall') {
        this.updatedviewall(actioned);
      }
    },

    error(message) {
      message && this.showError(message);
    }
  }
};
</script>
